import React from "react"
import Container from "./IconContainer"


const InsuranceIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="15px"
      height="18px"
      viewBox="0 0 15 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-106.000000, -1452.000000)"
          stroke="#505050"
          strokeWidth="1.5"
        >
          <g id="Group" transform="translate(107.000000, 1453.000000)">
            <g id="shield">
              <path
                d="M6.5,16 C6.5,16 13,12.8 13,8 L13,1.6 L6.5,0 L0,1.6 L0,8 C0,12.8 6.5,16 6.5,16 Z"
                id="Shape"
              />
            </g>
            <g id="check-copy-11" transform="translate(3.250000, 5.333333)">
              <polyline
                id="Shape"
                points="6.03571412 -4.6629367e-15 1.88616066 4.08571417 -3.99680289e-15 2.22857137"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default InsuranceIcon



// WEBPACK FOOTER //
// ./assets/common/components/icons/InsuranceIcon.js